module.exports = __webpack_public_path__ + "media/images/faces/face23-a3e592aebdbc726533fc1f141d1b89c7.jpg";